import React, { useEffect, useState } from "react";
import "./Content.css";
import { connect } from "react-redux";
import { FaRupeeSign } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
// import Loader from "../components/Loader/Loader.js";
import Loader from "../../../components/Loader/Loader";
// import cart_gray from "../../../Assets/cart_gray.svg";
import cart_empty from "../../../Assets/cart_empty.svg";
import cart_fill from "../../../Assets/cart_fill.svg";
//importing CARASOUL
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";
import {
  AddtoCart,
  getCartDetails,
  getPackageList,
} from "../../../Redux/Actions";
import { GiConvergenceTarget } from "react-icons/gi";

// for the notification
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

//RESPONSIVE SCRRREN
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function OurPackages(props) {
  const [pack, setPack] = useState([]);
  const packageList = useSelector((state) => state.packageList);
  const [openCartt, setOpenCartt] = useState(false);

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const [cartisempty, setcartisempty] = useState(true);
  const onCloseModalCartt = () => setOpenCartt(false);
  const [ItemInCart, setItemInCart] = useState([]);

  const { loading, packages } = packageList;
  const { results } = packages;

  const location = useLocation();

  const prePack = location?.pathname !== "/";

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(getPackageList());
  }, []);

  // const CartItems = useSelector((state) => state.CartReducer);

  // const itemIdArray = () => {
  //   if (CartItems.cartDetails) {
  //     CartItems.cartDetails[0].product.map((item) => {
  //       console.log(item, "here is item");
  //       ItemInCart.push(item.package.id);

  //     });

  //   }
  // };

  useEffect(() => {
    let newArray = [];
    if (props.CartItem && props.CartItem[0] && props.CartItem[0]?.product) {
      props.CartItem[0]?.product.map((item) => {
        newArray.push(item.package.id);
      });
      setItemInCart(newArray);
    } else {
      setItemInCart([])
    }
  }, [props.CartItem]);

  // const diffToast = () => {
  //   toast.success("Item added to cart", {
  //     position:"bottom-right"
  //   })
  //   toast.error("Item remove from cart", {
  //     position:"bottom-right"
  //   })
  // }

  // console.log(props.CartItem,"<<<<")

  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;
    dispatch(getCartDetails(token, citySelected?.citySelect));
  };

  const isLogout = useSelector((state) => state.setLogoutReducer);
  const [greenCart, setGreenCart] = useState();
  const greenCartCallBack = (tf) => {
    setGreenCart(tf);
  };
  useEffect(() => {
    if (isLogout.isLogout == "") {
      if (JSON.parse(localStorage.getItem("user"))) {
        setGreenCart(true, greenCartCallBack(true));
      } else {
        setGreenCart(false, greenCartCallBack(false));
      }
    } else if (isLogout.isLogout == true) {
      setGreenCart(false, greenCartCallBack(false));
    } else {
      setGreenCart(true, greenCartCallBack(true));
    }

    // console.log(isLogout.isLogout, "hdhdh", greenCart, "hdhdh");
  }, [isLogout]);

  function addtocart(packageid, packageslug) {
    setcartisempty(false);
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    const token = userFromLocal && userFromLocal.token;
    const body = {
      package: packageid,
    };
    if (token && token !== "") {
      dispatch(AddtoCart(body, token, successCb));
    } else {
      localStorage.setItem("packId", JSON.stringify(packageid));
      // history.push({
      //   pathname: "/login",
      //   packageId: packageid,
      //   pushToUrl: "cart"
      // });
      window.location.href = process.env.RAZZLE_APP_BASE_URL;
    }

    localStorage.setItem("packageSlug", packageslug);
    // console.log("clickedddddddddddddd")
    // console.log("props.values.slug", pack.slug)
    // localStorage.setItem("localslug", pack.slug);

    // toast.success("Item added to cart", {
    //   position: "bottom-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
  }
  const [firstScroll, setFirstScroll] = useState(false);
  const [hideDiv, setHideDiv] = useState(false);
  const [hideRightBtn, setHideRightBtn] = useState(true);
  const cardScroll = () => {
    const scrollPos = window.document.querySelector(".newProductListingCards");
    scrollPos.addEventListener(
      "scroll",
      (event) => {
        // console.log(scrollPos.scrollLeft);
        if (scrollPos.scrollLeft < 50) {
          setHideRightBtn(true);
          setFirstScroll(false);
        } else {
          setHideRightBtn(false);
        }
        if (scrollPos.scrollLeft > 100) {
          setHideDiv(true);
        } else {
          setHideDiv(false);
        }
      },
      { passive: true }
    );
  };
  const scrollLeft = () => {
    const scrollPos = window.document.querySelector(".newProductListingCards");
    if (screen.width > 1500) {
      if (!firstScroll) {
        setFirstScroll(true);
        scrollPos.scrollLeft += screen.width * 0.17;
      } else {
        scrollPos.scrollLeft += 390;
      }
    } else if (screen.width < 1500 && screen.width > 1280) {
      if (!firstScroll) {
        setFirstScroll(true);
        scrollPos.scrollLeft += screen.width * 0.177;
      } else {
        scrollPos.scrollLeft += 390;
      }
    } else if (screen.width < 1280 && screen.width > 700) {
      if (!firstScroll) {
        setFirstScroll(true);
        scrollPos.scrollLeft += screen.width * 0.19;
      } else {
        scrollPos.scrollLeft += 312;
      }
    } else {
      if (!firstScroll) {
        setFirstScroll(true);
        scrollPos.scrollLeft += 310;
      } else {
        scrollPos.scrollLeft += 312;
      }
    }
  };
  const scrollRight = () => {
    const scrollPos = window.document.querySelector(".newProductListingCards");
    if (screen.width > 1280) {
      scrollPos.scrollLeft -= 390;
    } else if (screen.width < 1280 && screen.width > 700) {
      scrollPos.scrollLeft -= 312;
    } else {
      scrollPos.scrollLeft -= 310;
    }
  };
  const viewAllPackages = () => {
    window.location.href = (process.env.RAZZLE_APP_BASE_URL + "/health-checkup-packages");
  };

  const [Mobwidth, setMobWidth] = useState("");

  useEffect(() => {
    function updateSize() {
      // if (typeof window !== "undefined") {
      setMobWidth(window.screen.width);
      // }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className={hideDiv ? "newPackageListingBg" : "newPackageListing"}>
        <div
          className={
            hideDiv
              ? "bestPackagesTitle bestPackagesTitleHide"
              : "bestPackagesTitle"
          }
        >
          <div className="trustedLabDiv">
            <img
              style={{ width: "30px" }}
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/516ee914-9798-4d7e-b438-cdeaac91e30d.svg"
              alt=""
            />
            &nbsp;
            <span className="trustedLabTxt"> India's Trusted Lab Network</span>
          </div>
          <div className="bestHealthPackagesDiv">Best Health</div>
          <div className="bestHealthPackagesDiv">
            Packages in{" "}
            {citySelected?.citySelect != ""
              ? citySelected?.citySelect
              : "India"}
          </div>
        </div>
        <div className="bestPackagesTitleMobile">
          <div className="trustedLabDiv">
            <img
              style={{ width: "20px" }}
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/516ee914-9798-4d7e-b438-cdeaac91e30d.svg"
              alt=""
            />
            &nbsp;
            <span className="trustedLabTxt"> India's Trusted Lab Network</span>
          </div>
          <div className="bestHealthPackagesDiv">
            Best Health Packages in{" "}
            {citySelected?.citySelect != ""
              ? citySelected?.citySelect
              : "India"}
          </div>
        </div>
        {/* <Carousel
          swipeable={true}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2500}
          transitionDuration={200}
          deviceType={"tablet"}
        >
         
        </Carousel> */}
        <div className="newProductListingCards" onScroll={cardScroll}>
          {packages &&
            packages.results &&
            packages.results.map((card, i) => (
              <div
                className={
                  card?.is_premium && prePack
                    ? i + 1 == packages.results.length
                      ? "Package__card Package__cardNew bgPremium lastCardMobile"
                      : "Package__card Package__cardNew bgPremium "
                    : i + 1 == packages.results.length
                      ? "Package__card Package__cardNew bgOrdinary lastCardMobile"
                      : "Package__card Package__cardNew bgOrdinary"
                }
                key={card.id}
              >
                <div
                  className={
                    card?.is_premium && prePack
                      ? "packageTopP packageTopHeight"
                      : "packageTopO packageTopHeight"
                  }
                >
                  {/* <span className={card?.is_premium && prePack ? "bgGreen" : "bgOrange"}>
                    {card.is_premium ? "Most Popular Plan" : "Heath Check-up"}
                  </span>{" "} */}
                  {/* <div
                    className={card?.is_premium && prePack ? "pTop" : "oTop"}
                    onClick={() => {
                      addtocart(card.id, card.slug);
                    }}
                  >
                    <div className="cart_div cart_textHeight">
                      <div
                        className={
                          card?.is_premium && prePack
                            ? "hover_blue"
                            : "hover_gray"
                        }
                      >
                        {ItemInCart.includes(card.id) ? (
                          <img src={cart_fill} alt="cart icon" />
                        ) : (
                          <img src={cart_empty} alt="cart icon" />
                        )}
                      </div> */}

                  {/* <img src={ cartisempty ? cart_empty : cart_fill} alt="cart icon" /> */}
                  {/* </div>
                  </div> */}
                  <div>
                    <div className="Package__cardTitle Package__cardPadding  blogPackageTitle blogPackageTitleNew">
                      <span
                        className={
                          card?.is_premium && prePack
                            ? "textWhite"
                            : "textBluee "
                        }
                      >
                        <a
                          className={
                            card?.is_premium && prePack
                              ? "textWhite"
                              : "textBluee txtBlack"
                          }
                          href={`/${card.slug}${citySelected.citySelect != ""
                            ? `/${citySelected.citySelect
                              .toLowerCase()
                              .replace(" ", "-")}`
                            : ""
                            }`}
                        >
                          {/* {card.name} */}
                          {card.name.length < 47
                            ? card.name
                            : `${card.name.substring(0, 47)}...`}
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="packageBottom packageBottomNew">
                  {/* <div className="Package__cardTitle">
                  <span
                    className={
                      card?.is_premium && prePack ? "textWhite" : "textBlue "
                    }
                  >
                    <Link
                      className={
                        card?.is_premium && prePack ? "textWhite" : "textBlue "
                      }
                      
                      to={`/${card.slug}${citySelected.citySelect != '' ? `-${citySelected.citySelect
                            .toLowerCase()
                            .replace(" ", "-")}` : ''}`}
                    >
                      {card.name}
                    </Link>
                  </span>
                </div> */}
                  <div className="Package__cardList Package__cardListNew">
                    <ul>
                      <li>
                        {" "}
                        <img
                          className="checkIconProductListing"
                          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8d216596-4708-4fe9-99bd-a51667e929ac.svg"
                          alt=""
                        />{" "}
                        Total no.of Tests - {card?.parameter}{" "}
                      </li>
                      <li>
                        {" "}
                        <img
                          className="checkIconProductListing"
                          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8d216596-4708-4fe9-99bd-a51667e929ac.svg"
                          alt=""
                        />{" "}
                        Quick Turn Around Time{" "}
                      </li>
                      <li>
                        {" "}
                        <img
                          className="checkIconProductListing"
                          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8d216596-4708-4fe9-99bd-a51667e929ac.svg"
                          alt=""
                        />{" "}
                        Reporting as per NABL ISO guidelines{" "}
                      </li>
                    </ul>
                  </div>
                  <hr style={{ width: "100%", opacity: "0.3" }} />
                  <div className="Package__cardPrice Package__cardPriceNew">
                    {/* <span
                      className={
                        card?.is_premium && prePack ? "text_Color" : "card__Mrp"
                      }
                    >
                      {" "}
                      MRP : &#8377; {card?.package_price}
                    </span> */}
                    <span
                      className={
                        card.is_premium && prePack
                          ? " card__offerPrice textSizeSmall "
                          : "   card__offerPrice textGrey textSizeSmall"
                      }
                    >
                      {" "}
                      Offer Price:
                      <div className="newOfferPriceValue">
                        &#8377;{card?.offer_price}{" "}
                        <span className="overlinedPriceNew">
                          &#8377;{card?.package_price}
                        </span>
                      </div>
                    </span>
                  </div>
                  {cartisempty != false ? (
                    <div className="newCardBottom">
                      <a
                        className="Package__BookButton Package__BookButtonNew"
                        href={`/${card.slug}${citySelected.citySelect != ""
                          ? `/${citySelected.citySelect
                            .toLowerCase()
                            .replace(" ", "-")}`
                          : ""
                          }`}
                      >
                        <span>Book Now</span>
                      </a>
                      <div
                        onClick={() => {
                          addtocart(card.id, card.slug);
                        }}
                        className="cart_div cart_textHeight"
                      >
                        <div
                          className={
                            card?.is_premium && prePack
                              ? "hover_blue"
                              : "hover_gray"
                          }
                        >
                          {greenCart && ItemInCart.includes(card.id) ? (
                            <img
                              className={
                                card?.is_premium && prePack
                                  ? "cartImageWidth cartImageWidthBlue"
                                  : "cartImageWidth"
                              }
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b6578829-e177-4cbf-953d-837b4b23349d.svg"
                              alt="cart icon"
                            />
                          ) : (
                            <img
                              className={
                                card?.is_premium && prePack
                                  ? "cartImageWidth cartImageWidthBlue"
                                  : "cartImageWidth"
                              }
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5bb9daa5-5ee2-489c-810d-d7a4dbc9f9aa.svg"
                              alt="cart icon"
                            />
                          )}
                        </div>

                        {/* <img src={ cartisempty ? cart_empty : cart_fill} alt="cart icon" /> */}
                      </div>
                    </div>
                  ) : (
                    <div className="newCardBottom">
                      <a
                        className="Package__BookButton Package__BookButtonNew"
                        href={process.env.RAZZLE_APP_BASE_URL + "/cart"}
                      >
                        <span>Book Now</span>
                      </a>
                      <div
                        onClick={() => {
                          addtocart(card.id, card.slug);
                        }}
                        className="cart_div cart_textHeight"
                      >
                        <div
                          className={
                            card?.is_premium && prePack
                              ? "hover_blue"
                              : "hover_gray"
                          }
                        >
                          {ItemInCart.includes(card.id) ? (
                            <img
                              className={
                                card?.is_premium && prePack
                                  ? "cartImageWidth cartImageWidthBlue"
                                  : "cartImageWidth"
                              }
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b6578829-e177-4cbf-953d-837b4b23349d.svg"
                              alt="cart icon"
                            />
                          ) : (
                            <img
                              className={
                                card?.is_premium && prePack
                                  ? "cartImageWidth cartImageWidthBlue"
                                  : "cartImageWidth"
                              }
                              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5bb9daa5-5ee2-489c-810d-d7a4dbc9f9aa.svg"
                              alt="cart icon"
                            />
                          )}
                        </div>

                        {/* <img src={ cartisempty ? cart_empty : cart_fill} alt="cart icon" /> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}


          <div className="Package__card Package__cardLast bgOrdinary ">
            <a
              className="viewAllLink"
              href={process.env.RAZZLE_APP_BASE_URL + `/health-checkup-packages${citySelected?.citySelect
                ? `/${citySelected?.citySelect
                  .toLowerCase()
                  .replace(" ", "-")}`
                : ""
                }`}
            >
              View All&nbsp;
              <AiOutlineRight />
            </a>{" "}
          </div>
        </div>

        <div className="mobileViewAll">
          <button onClick={viewAllPackages} className="viewAllBtn">
            View All
          </button>
        </div>
        {Mobwidth >= 760 ? (
          <div>
            <div className="leftBtnProductListing">
              <button onClick={scrollLeft} className="BtnProductListing">
                <AiOutlineRight />
              </button>
            </div>
            <div
              className={hideRightBtn ? "displayNone1" : "rightBtnProductListing"}
            >
              <button onClick={scrollRight} className="BtnProductListing">
                <AiOutlineLeft />
              </button>
            </div>
          </div>
        ) : <div></div>}
      </div>

      {/* <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ fontSize: "1.8rem" }}
      /> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  CartItem: state?.CartReducer?.cartDetails,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(OurPackages));
